module.exports = __webpack_public_path__ + "img/Listening.0c40093e.gif";